import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17d0e4ec")

_pushScopeId("data-v-17d0e4ec")
const _hoisted_1 = {
  class: "btn ques-hint",
  type: "button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("button", _hoisted_1, [
    _createVNode(_component_svg_icon, { name: "questionMark" }),
    _createVNode("div", {
      class: ["ques-hint__content", [$props.sides]]
    }, _toDisplayString($props.title), 3)
  ]))
})